import React from "react";

import styles from "./rfiStepperProgress.module.scss";

const RFIStepperProgress = ({ status }) => (
  <div className="d-flex mb-5">
    <div
      className={`${styles.progressDotWrapper} ${
        status === "submitted" ? styles.active : ""
      }`}
    >
      <span>Completed</span>
      <div className={styles.dotWithBorder}>
        <span />
      </div>
    </div>
    <div
      className={`${styles.progressDotWrapper} ${
        status === "submitted" ? styles.active : ""
      }`}
    >
      <span>Submitted</span>
      <div className={styles.dotWithBorder}>
        <span />
      </div>
    </div>
    <div
      className={`${styles.progressDotWrapper} ${
        status === "review" ? styles.active : ""
      }`}
    >
      <span>Reviewed</span>
      <div className={styles.dotWithBorder}>
        <span />
      </div>
    </div>
    <div
      className={`${styles.progressDotWrapper} ${
        status === "accepted" ? styles.active : ""
      }`}
    >
      <span>Accepted</span>
      <div>
        <span />
      </div>
    </div>
  </div>
);

export default React.memo(RFIStepperProgress);
